var React = require('react');

function CampaignTrimmed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.052 1.18A.882.882 0 0 1 1.726.623l4.582 13.746-1.674.558L.052 1.181zM2.647.883C3.506.294 4.535 0 5.735 0c1.83 0 2.809 1.765 5.294 1.765 1.575 0 2.604-.294 3.089-.883.005 1.472-.585 2.649-1.769 3.53-1.776 1.321-3.593.534-5.29 1.764-1.132.821-1.72 1.703-1.765 2.648L2.647.882z","fill":"#000","fillRule":"nonzero"}));
}

CampaignTrimmed.defaultProps = {"width":"15","height":"15"};

module.exports = CampaignTrimmed;

CampaignTrimmed.default = CampaignTrimmed;
